<template>
  <div class="module_page page_content institution" aria-label="Institution Configuration view content page">
    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container">
        <b-btn @click="doneClicked">done</b-btn>
        <b-btn @click="saveClicked">save</b-btn>
        <b-btn class="btn-cancel" @click="cancelClicked" title="Cancel"><span class="icon-cross"></span></b-btn>
      </div>
    </div>
    <div class="page_content_container">
      <institution-menu :uuid="uuid" :active="'configuration'"></institution-menu>
      <div class="row pg_content">
        <div class="col-12">
          <div class="row">
            <div class="col-12 pg_fld_sec">
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Current Semester</label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="201880" v-model="currentSemester"></input>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Semester Map</label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="{'201880': 'Fall 2018'}" v-model="semesterMap"></input>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Year Map</label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="{'2017-2018': ['201780', '201810']}" v-model="yearMap"></input>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Term Map With Cut-Off Date</label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder='{"202010": {"label": "Spring 2020", "cutOff": "02/20/2020"}}' v-model="termMapWithCutOffDate"></input>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Institution Email Recipients </label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="user1@email.com, user2@email.com..." v-model="emailRecipients"></input>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Institution Email Sender </label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="user@email.com" v-model="emailSender"></input>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Auto Provision </label>
                  </div>
                  <div class="fld_input">
                    <input type="checkbox" v-model="autoProvision" style="float: left; margin: -1px 7px 0px 4px; width: 25px; height: 25px;">
                    Enable Auto Provision
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label" for="autoProvisionRole">Auto Provision Role</label>
                  </div>
                  <div class="fld_input">
                    <select id="autoProvisionRole" v-model="autoProvisionRole">
                      <option v-for="role in autoProvisionRoles" v-bind:value="role">
                        {{ role }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row prog_email_cron_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Progress Email Cron</label>
                  </div>
                  <div class="fld_input">
                    <div id="progress-email-cron" class="cron-builder mb-3"></div>
                    <div>
                      <input type="text" placeholder="0 0 12 1 1 ? *" v-model="progressEmailCron" disabled class="prog_email_cron_exp"></input>
                      <b-btn @click="generateCron" style="height: 40px; margin-top: -6px;">generate cron</b-btn>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Education Level Configuration</label>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Some High School</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="someHighSchool"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">High School</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="highSchool"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Certificate</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="certificate"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Associate</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="associate"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Bachelor</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="bachelor"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Master</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="master"></input>
                  </div>
                  <div class="prog_email_cron_label_top">
                    <label class="prog_email_cron_label">Doctoral</label>
                  </div>
                  <div class="fld_input">
                    <input type="number" placeholder="0.0" v-model="doctoral"></input>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Guest User Session Count </label>
                  </div>
                  <div class="fld_input">
                    <input type="text" placeholder="100" v-model="guestUserSessionCount"></input>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Partner Institutions </label>
                  </div>
                  <div class="fld_input">
                    <multiselect v-model="partnerInstitutions" :options="availableInstitutions" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Partner Institutions" label="title" track-by="uuid" :preselect-first="true" style="width: 96%;">
                      <template slot="selection" slot-scope="{values, search, isOpen}"><span class="multiselect__single" v-if="values.length && !isOpen">{{values.length}} institutions selected</span></template>
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Categories </label>
                  </div>
                  <div class="fld_input transfer_articulation_input">
                    <div style="width: 98%;">
                      <div class="custom_tags_container">
                        <span class="custom_tag" v-for="(customCategory, index) in transferArticulationCustomCategories" :title="customCategory">
                          <span class="custom_tag_name">{{customCategory}}</span>
                          <span class="action">
                            <span class="delete-icon" @click="removeCategory(index)" title="delete category">
                              <i class="icon-bin" aria-hidden="true"></i>
                            </span>
                          </span>
                        </span>
                      </div>
                      <div class="btn_container">
                        <span class="add-icon" title="add category" id="addCategory">
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Terms </label>
                  </div>
                  <div class="fld_input transfer_articulation_input">
                    <div style="width: 98%;">
                      <div class="custom_tags_container">
                        <span class="custom_tag" v-for="(customTerm, index) in transferArticulationCustomTerms" :title="customTerm">
                          <span class="custom_tag_name">{{customTerm}}</span>
                          <span class="action">
                            <span class="delete-icon" @click="removeTerm(index)" title="delete term">
                              <i class="icon-bin" aria-hidden="true"></i>
                            </span>
                          </span>
                        </span>
                      </div>
                      <div class="btn_container">
                        <span class="add-icon" title="add term" id="addTerm">
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Grades </label>
                  </div>
                  <div class="fld_input transfer_articulation_input">
                    <div style="width: 98%;">
                      <div class="custom_tags_container">
                        <span class="custom_tag" v-for="(customGrade, index) in transferArticulationCustomGrades" :title="'Text: ' + customGrade.text + ', Value: ' + customGrade.value">
                          <span class="custom_tag_name">{{customGrade.text}}</span>
                          <span class="action">
                            <span class="delete-icon" @click="removeGrade(index)" title="delete term">
                              <i class="icon-bin" aria-hidden="true"></i>
                            </span>
                          </span>
                        </span>
                      </div>
                      <div class="btn_container">
                        <span class="add-icon" title="add term" id="addGrade">
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-popover ref="addCategoryPopover" target="addCategory" triggers="click" @show="onCategoryShow" @shown="onCategoryShown" :show.sync="showAddCategoryPopover">
      <template slot="title">
        <button class="btn_close" aria-label="close" @click="showAddCategoryPopover = false">
          <span class="ic-close"></span>
        </button>
        <span class="title">Add Category</span>
      </template>

        <div @keydown.enter="addCategory">
            <b-form-group
              :state="categoryState"
              class="mb-1"
              :invalid-feedback="invalidCategory">
              <b-form-input
                ref="categoryName"
                id="category-name"
                v-model.trim="category"
                size="sm"
                placeholder="Type Category Name"
                @input="forceUpperCase($event, 'category')"
              ></b-form-input>
            </b-form-group>
        </div>
        <div class="modal-footer">
         <b-button @click="addCategory" size="sm" variant="primary">add</b-button>
       </div>
    </b-popover>
    <b-popover ref="addTermPopover" target="addTerm" triggers="click" @show="onTermShow" @shown="onTermShown" :show.sync="showAddTermPopover">
      <template slot="title">
        <button class="btn_close" aria-label="close" @click="showAddTermPopover = false">
          <span class="ic-close"></span>
        </button>
        <span class="title">Add Term</span>
      </template>

        <div @keydown.enter="addTerm">
            <b-form-group
              :state="termState"
              class="mb-1"
              :invalid-feedback="invalidTerm">
              <b-form-input
                ref="termName"
                id="term-name"
                v-model.trim="term"
                size="sm"
                placeholder="Type Term Name"
              ></b-form-input>
            </b-form-group>
        </div>
        <div class="modal-footer">
         <b-button @click="addTerm" size="sm" variant="primary">add</b-button>
       </div>
    </b-popover>
    <b-popover ref="addGradPopover" target="addGrade" triggers="click" @show="onGradeShow" @shown="onGradeShown" :show.sync="showAddGradePopover">
      <template slot="title">
        <button class="btn_close" aria-label="close" @click="showAddGradePopover = false">
          <span class="ic-close"></span>
        </button>
        <span class="title">Add Grade</span>
      </template>

        <div @keydown.enter="addGrade">
          <b-form-group
            :state="gradeState"
            class="mb-1"
            :invalid-feedback="invalidGrade">
            <b-form-input
              ref="gradeText"
              id="grade-text"
              v-model.trim="gradeText"
              size="sm"
              placeholder="Type Grade Text"
              @input="forceUpperCase($event, 'gradeText')"
            ></b-form-input>
            <b-form-input
              ref="gradeValue"
              id="grade-value"
              v-model.trim="gradeValue"
              size="sm"
              placeholder="Type Grade Value"
              @input="forceUpperCase($event, 'gradeValue')"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="modal-footer">
         <b-button @click="addGrade" size="sm" variant="primary">add</b-button>
       </div>
    </b-popover>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import InstitutionMenu from './InstitutionMenu'
  import InstitutionHeader from './InstitutionHeader'
  import '../../../jquery_cron_builder.js'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  export default {
    name: 'editInstitutionConfiguration',
    props: ['uuid'],
    components: {
      InstitutionMenu,
      InstitutionHeader
    },
    data: () => {
      return {
        currentSemester: '',
        semesterMap: {},
        semesterMapToSave: {},
        yearMap: {},
        yearMapToSave: {},
        guestUserSessionCount: 0,
        autoProvision: false,
        autoProvisionRole: false,
        autoProvisionRoles: ['Student', 'Instructor', 'Instructor & Admin', 'Advisor', 'Employer Admin', 'Coach', 'Observer', 'Curator', 'Recruiter', 'Prospective Student'],
        emailRecipients: '',
        emailSender: '',
        progressEmailCron: '0 0 12 1 1 ? *',
        errors: [],
        someHighSchool: 0.0,
        highSchool: 0.0,
        certificate: 0.0,
        associate: 0.0,
        bachelor: 0.0,
        master: 0.0,
        doctoral: 0.0,
        termMapWithCutOffDate: {},
        termMapWithCutOffDateToSave: {},
        availableInstitutions: [],
        partnerInstitutions: [],
        term: '',
        termState: null,
        showAddTermPopover: false,
        transferArticulationCustomTerms: [],
        gradeText: '',
        gradeValue: '',
        gradeState: null,
        showAddGradePopover: false,
        transferArticulationCustomGrades: [],
        category: '',
        categoryState: null,
        showAddCategoryPopover: false,
        transferArticulationCustomCategories: []
      }
    },
    watch: {
      category (val) {
        if (val) {
          this.categoryState = true
        }
      },
      term (val) {
        if (val) {
          this.termState = true
        }
      },
      gradeText (val) {
        if (val && this.gradeValue) {
          this.gradeState = true
        }
      },
      gradeValue (val) {
        if (val && this.gradeText) {
          this.gradeState = true
        }
      }
    },
    async beforeMount () {
      this.availableInstitutions = await this.loadAllAvailableInstitutions()
    },
    mounted () {
      this.loadData()
      $('#progress-email-cron').cronBuilder()
    },
    methods: {
      ...mapActions([
        'loadLibrariesForUser',
        'loadInstitutionDetail',
        'loadInstitutionConfiguration',
        'storeInstitution',
        'loadLogDashboardActivity',
        'loadAllAvailableInstitutions'
      ]),
      forceUpperCase (e, prop) {
        e = e.trim().toUpperCase()
        this.$set(this.$data, prop, e)
      },
      onCategoryShow () {
        this.category = ''
        this.categoryState = null
      },
      onCategoryShown () {
        this.focusRef(this.$refs.categoryName)
      },
      onTermShow () {
        this.term = ''
        this.termState = null
      },
      onTermShown () {
        this.focusRef(this.$refs.termName)
      },
      onGradeShow () {
        this.gradeText = ''
        this.gradeValue = ''
        this.gradeState = null
      },
      onGradeShown () {
        this.focusRef(this.$refs.gradeText)
      },
      focusRef (ref) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            (ref.$el || ref).focus()
          })
        })
      },
      addCategory () {
        if (!this.category) {
          this.categoryState = false
        }
        if (this.categoryState) {
          this.transferArticulationCustomCategories.push(this.category)
          this.onCategoryShow()
          this.showAddCategoryPopover = false
        }
      },
      removeCategory (index) {
        this.transferArticulationCustomCategories.splice(index, 1)
      },
      addTerm () {
        if (!this.term) {
          this.termState = false
        }
        if (this.termState) {
          this.transferArticulationCustomTerms.push(this.term)
          this.onTermShow()
          this.showAddTermPopover = false
        }
      },
      removeTerm (index) {
        this.transferArticulationCustomTerms.splice(index, 1)
      },
      addGrade () {
        if (!this.gradeText || !this.gradeValue) {
          this.gradeState = false
        }
        if (this.gradeState) {
          let grade = {text: this.gradeText, value: this.gradeValue}
          this.transferArticulationCustomGrades.push(grade)
          this.onGradeShow()
          this.showAddGradePopover = false
        }
      },
      removeGrade (index) {
        this.transferArticulationCustomGrades.splice(index, 1)
      },
      loadData () {
        let institutionId = this.institutionId
        this.loadInstitutionDetail(institutionId).then(response => {
          if (!response || !response.uuid) {
            return
          }
          this.guestUserSessionCount = response.guestUserSessionCount
          this.currentSemester = response.currentSemester
          this.semesterMap = response.semesterMap ? JSON.stringify(response.semesterMap) : ''
          this.yearMap = response.yearMap ? JSON.stringify(response.yearMap) : ''
          this.autoProvision = response.autoProvision
          this.autoProvisionRole = response.autoProvisionRole
          this.emailRecipients = response.emailRecipients ? response.emailRecipients.split(',').join(', ') : ''
          this.emailSender = response.emailSender
          this.progressEmailCron = response.progressEmailCron
          this.termMapWithCutOffDate = response.termMapWithCutOffDate ? JSON.stringify(response.termMapWithCutOffDate) : ''
          this.partnerInstitutions = response.partnerInstitutions
          this.transferArticulationCustomTerms = response.transferArticulationCustomTerms
          this.transferArticulationCustomGrades = response.transferArticulationCustomGrades
          this.transferArticulationCustomCategories = response.transferArticulationCustomCategories
          if (response.educationLevelConfiguration) {
            this.someHighSchool = response.educationLevelConfiguration.someHighSchool
            this.highSchool = response.educationLevelConfiguration.highSchool
            this.certificate = response.educationLevelConfiguration.certificate
            this.associate = response.educationLevelConfiguration.associate
            this.bachelor = response.educationLevelConfiguration.bachelor
            this.master = response.educationLevelConfiguration.master
            this.doctoral = response.educationLevelConfiguration.doctoral
          }
        })
        // this.$forceUpdate() // ensure the backend fields are populated in the input forms
      },
      institutionDataIsValid () {
        let isValid = true
        try {
          let semesterMap = this.semesterMap ? JSON.parse(this.semesterMap) : {}
          this.semesterMapToSave = semesterMap
        } catch (err) {
          this.errors.push('Malformed JSON detected for \'Semester Map\'')
          isValid = false
        }
        try {
          let yearMap = this.yearMap ? JSON.parse(this.yearMap) : {}
          this.yearMapToSave = yearMap
        } catch (err) {
          this.errors.push('Malformed JSON detected for \'Year Map\'')
          isValid = false
        }
        try {
          let termMapWithCutOffDate = this.termMapWithCutOffDate ? JSON.parse(this.termMapWithCutOffDate) : {}
          this.termMapWithCutOffDateToSave = termMapWithCutOffDate
        } catch (err) {
          this.errors.push('Malformed JSON detected for \'Term Map With Cutoff Date\'')
          isValid = false
        }
        return isValid
      },
      cancelClicked () {
        return this.$router.push({ name: 'institutionConfiguration', params: { uuid: this.uuid } })
      },
      saveClicked () {
        let redirectToConfigurationPage = false
        this.onSubmit(redirectToConfigurationPage)
      },
      doneClicked () {
        let redirectToConfigurationPage = true
        this.onSubmit(redirectToConfigurationPage)
      },
      generateCron () {
        let current = $('#progress-email-cron').data('cronBuilder').getExpression()
        this.progressEmailCron = current
      },
      onSubmit (isDone) {
        if (!this.institutionDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        let institution = this.institution
        let educationLevelConfiguration = {
          someHighSchool: this.someHighSchool,
          highSchool: this.highSchool,
          certificate: this.certificate,
          associate: this.associate,
          bachelor: this.bachelor,
          master: this.master,
          doctoral: this.doctoral
        }

        if (this.someHighSchool < 0 || this.highSchool < 0 || this.certificate < 0 || this.associate < 0 || this.bachelor < 0 || this.master < 0 || this.doctoral < 0) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Education Level must be greater than zero'
          })
          return
        }
        const institutionData = {
          uuid: institution.uuid,
          title: institution.title,
          level: institution.level,
          description: institution.description,
          type: institution.type,
          orgType: institution.orgType,
          uri: institution.uri,
          address: institution.address,
          phonenumber: institution.phonenumber,
          faxnumber: institution.faxnumber,
          openId: institution.openId,
          ssoUrl: institution.ssoUrl,
          ssoLogoutUrl: institution.ssoLogoutUrl,
          path: institution.path,
          redirectUrl: institution.redirectUrl,
          logo: institution.logo,
          autoTaggingEnable: institution.autoTaggingEnable,
          courseDiscoveryConfigurationEnable: institution.courseDiscoveryConfigurationEnable,
          createPersonProfile: institution.createPersonProfile,
          customLandingPageViewer: institution.customLandingPageViewer,
          debugSearchRelevance: institution.debugSearchRelevance,
          employmentDataProvider: institution.employmentDataProvider,
          enableDashboard: institution.enableDashboard,
          enableExplore: institution.enableExplore,
          lmsConnectorPackage: institution.lmsConnectorPackage,
          mc3Integration: institution.mc3Integration,
          nlpSearchEnable: institution.nlpSearchEnable,
          packages: institution.packages,
          pollingTimeMessages: institution.pollingTimeMessages,
          pollingTimeNotifications: institution.pollingTimeNotifications,
          sharePlanningStream: institution.sharePlanningStream,
          showDefaultLandingPage: institution.showDefaultLandingPage,
          showDuplicateContent: institution.showDuplicateContent,
          streamConfiguration: institution.streamConfiguration,
          currentSemester: this.currentSemester, // fields to save
          semesterMap: this.semesterMapToSave, // save JSON.parse(this.semesterMap) to serialize
          yearMap: this.yearMapToSave, // save JSON.parse(this.yearMap) to serialize
          autoProvision: this.autoProvision,
          autoProvisionRole: this.autoProvisionRole,
          emailRecipients: this.emailRecipients.length > 0 ? this.emailRecipients.split(',').map(email => email.trim()).join(',') : '',
          emailSender: this.emailSender ? this.emailSender.trim() : '',
          guestUserSessionCount: this.guestUserSessionCount,
          progressEmailCron: this.progressEmailCron, // end fields to save
          educationLevelConfiguration: educationLevelConfiguration,
          termMapWithCutOffDate: this.termMapWithCutOffDateToSave,
          partnerInstitutions: this.partnerInstitutions,
          transferArticulationCustomTerms: this.transferArticulationCustomTerms,
          transferArticulationCustomGrades: this.transferArticulationCustomGrades,
          transferArticulationCustomCategories: this.transferArticulationCustomCategories
        }
        this.showLoader()
        this.storeInstitution(institutionData).then(response => {
          this.hideLoader()
          if (this.isSuccessfulResponse(response)) {
            let message = '\'' + institution.title + '\' Configuration updated successfully.'
            this.notifySuccess(message)
          } else {
            let message = 'Unable to update Configuration for ' + '\'' + institution.title + '\''
            this.notifyFailure(message)
          }
          if (isDone) {
            return this.$router.push({ name: 'institutionConfiguration', params: { uuid: this.uuid } })
          }
        })
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      isSuccessfulResponse (response) {
        return response && response.uuid
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      }),
      institutionId () {
        let uuid = this.uuid
        if (!uuid || uuid.length <= 0) {
          uuid = localStorage.getItem('institutionId') || JSON.parse(localStorage.getItem('userobj')).institutionId
        }
        return uuid
      },
      invalidCategory () {
        if (!this.category) {
          return 'Category name is required'
        } else {
          let found = this.transferArticulationCustomCategories.find((category, index) => {
            return (this.category === category)
          })
          if (found) {
            this.categoryState = false
            return 'Category already exists'
          }
        }
      },
      invalidTerm () {
        if (!this.term) {
          return 'Term name is required'
        } else {
          let found = this.transferArticulationCustomTerms.find((term, index) => {
            return (this.term.toLowerCase() === term.toLowerCase())
          })
          if (found) {
            this.termState = false
            return 'Term already exists'
          }
        }
      },
      invalidGrade () {
        if (!this.gradeText) {
          return 'Grade text is required'
        } else if (!this.gradeValue) {
          return 'Grade value is required'
        } else {
          let found = this.transferArticulationCustomGrades.find((grade, index) => {
            return (this.gradeText.toLowerCase() === grade.text.toLowerCase())
          })
          if (found) {
            this.gradeState = false
            return 'Grade already exists'
          }
        }
      }
    }
  }
</script>
<style scoped>
  .prog_email_cron_row {
    width: 90%;
    margin: auto;
    margin-bottom: 30px;
  }
  . prog_email_cron_label_top {
    margin-bottom: 0;
    color: #5c5539;
    font-size: 18px;
  }
  .prog_email_cron_label {
    margin-bottom: 10px;
    color: #5c5539;
    font-size: 18px;
    font-weight: 600;
  }
  .prog_email_cron_exp {
    width: 65%;
    color: #616161;
    font-size: 18px;
    padding: 0.5rem;
  }
  .transfer_articulation_input {
    border: solid 1px #d1d1d1;
    width: 96%;
    float: left;
  }
  .custom_tags_container {
    float: left;
    width: calc(100% - 30px);
    overflow: auto;
    max-height: 85px;
  }
  .btn_container {
    float: right;
    width: 20px;
    padding: 5px;
    color: #157099;
    cursor: pointer;
  }
  .custom_tag {
    float: left;
    display: flex;
    margin: 0px 5px 5px 0px;
    border: 1px solid #b3b3b3;
    border-radius: 3px;
    color: #303030;
  }
  .custom_tag_name {
    width: 175px;
    padding: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: #e6e6e6;
  }
  .action {
    background: #fff;
    padding: 0px 5px;
    width: 32px;
  }
  .delete-icon {
    float: left;
    color: #157099;
    font-size: 24px;
    margin: 1px 5px 0 0;
  }
  .popover #term-name, .popover #grade-text, .popover #grade-value, .popover #category-name {
    width: 80%;
    margin: 5px 5px 5px 10px;
  }
  .invalid-feedback {
    width: 100%;
    margin: .25rem .5rem;
    font-size: 80%;
    color: #dc3545;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/EditInstitutionConfiguration.vue